import { gql } from '@apollo/client';

export const LISTAR_ESTADOS = gql`
  query ListarEstados {
    estados {
      id
      nome
      uf
    }
  }
`;

export const LISTAR_CIDADES = gql`
  query ListarCidades {
    cidades {
      id
      nome
      estado {
        id
        nome
        uf
      }
      uf
    }
  }
`;

export interface Estado {
  id: string;
  nome: string;
  uf: string;
}

export interface Cidade {
  id: string;
  nome: string;
  estado: Estado;
  uf: string;
}
